import { CommunicationMarketingConsent } from "@hubcapp/types";
import { getCapitalizedString } from "@hubcapp/utils";

type MarketingKey = keyof CommunicationMarketingConsent;

/**
 * Returns a string representation of the given contact preferences object,
 * which contains the user's communication marketing consent options.
 * @param {CommunicationMarketingConsent | undefined} marketing - The user's communication marketing consent object
 * @returns {string} The comma-separated string representation of the user's communication marketing preferences,
 * or '-' if no preferences are found. String 'sms' should display like "SMS"
 */
export const getContactPreferencesString = (
  marketing: CommunicationMarketingConsent | undefined,
): string =>
  (Object.keys(marketing || []) as MarketingKey[])
    .filter(key => typeof marketing?.[key] === "boolean" && marketing?.[key])
    .map(key =>
      key.toLowerCase() === "sms" ? "SMS" : getCapitalizedString(key),
    )
    .join(", ") || "-";
